import React, { useState, useEffect } from 'react';

import { ApplicationLog } from './ApplicationLog';

import './PythonLogs.css';


export function PythonLogs({logs}: {logs: ApplicationLog[]}) {
  const logsItems = logs.map((log: ApplicationLog) => {
    if(log.level == 'error') {
      return ( <div key={log.id} className='python_logs_error'> {log.message} </div> );
    }

    if(log.level == 'truncated') {
      return ( <div key={log.id} className='python_logs_truncated'> {log.message} </div> );
    }

    return (<div key={log.id} className='python_logs_info'> {log.message} </div>);

  });

  return (<div className='python_logs'> {logsItems} </div>);
}
